export { default, type Props as CommunityEventsSectionProps } from './CommunityEventsSection';
